/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'

import colors from '../../../../../assets/colors'
import ReactInputMask from 'react-input-mask'
import { mdiProgressUpload } from '@mdi/js'
import Icon from '@mdi/react'
import {
  fetchCnpjInfo,
  fetchViaCep,
  store,
  update,
} from '../../../LaundryEletronicInvoiceActions'
import { SNACKBAR } from '../../../../main/MainActions'
import { isCpfCnpjValid } from '../../../../../util/cpf_cnpj_validator'
import { Forms } from './Form'

const useStyles = makeStyles({
  subTitle: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  company_box: {
    padding: '8px',
    borderRadius: '3px',
    boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.2)',
  },
  details_box: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    // padding: '16px',
    borderRadius: '24px',
    // border: '1px solid',
    // borderColor: colors.graylight,
    display: 'flex',
    flexDirection: 'column',
  },
  btnSave: {
    borderRadius: '20px',
    color: '#FFF',
    backgroundColor: colors.primary,
    fontSize: '12px',
    textTransform: 'capitalize',
    width: '101px',
    padding: '4px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: '.7',
    },
  },
  uploadLogo: {
    width: '100%',
    height: '100%',
    border: `1px dashed ${colors.primary}`,
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    fontSize: '14px',
    borderRadius: '10px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: '#FFF',
      opacity: '.6',
    },
  },
  certificateStatus: {
    fontSize: '12px',
    color: colors.graylight,
  },
  cartifacateValidate: {
    backgroundColor: colors.bgSucess,
    borderRadius: '15px',
    color: colors.primary,
    fontSize: '12px',
  },
})

const LaundryConfig = ({
  haveRegistration = false,
  setHaveRegistration = () => {},
  reloadVerifyRegistratiron = () => {},
  registrationData,
}) => {
  const dispatch = useDispatch()

  const classes = useStyles()
  const inputRef = useRef()

  const [form, setForm] = useState({
    cnpj: '',
    nome: '',
    nome_fantasia: '',
    inscricao_estadual: '',
    inscricao_municipal: '',
    regime_tributario: '',
    arquivo_certificado_base64: '',
    senha_certificado: '',

    email: '',
    telefone: '',

    cep: '',
    municipio: '',
    numero: '',
    uf: '',
    logradouro: '',
    complemento: '',
    bairro: '',

    nome_responsavel: '',
    cpf_responsavel: '',
    login_responsavel: '',
    senha_responsavel: '',
    senha_responsavel_preenchida: '',
    arquivo_logo_base64: '',
  })

  const [validatedForm, setValidatedForm] = useState({
    cnpj: '',
    nome: '',
    nome_fantasia: '',
    inscricao_municipal: '',
    regime_tributario: '',
    arquivo_certificado_base64: '',
    senha_certificado: '',

    email: '',
    telefone: '',

    cep: '',
    municipio: '',
    numero: '',
    uf: '',
    logradouro: '',
    bairro: '',

    nome_responsavel: '',
    cpf_responsavel: '',
    login_responsavel: '',
    senha_responsavel: '',
  })

  const ignoreIfHaveRegistration = [
    'senha_responsavel',
    'arquivo_certificado_base64',
    'senha_certificado',
  ]

  const handleChange = e => {
    e.preventDefault()

    const { name, value } = e.target

    setForm({
      ...form,
      [name]: value,
    })

    setValidatedForm({
      ...validatedForm,
      [name]: '',
    })
  }

  const handleChooseFile = () => {
    inputRef.current.click()
  }

  const handleChangeCertificate = event => {
    const { files } = event.target

    if (files[0] == null) {
      return setForm({
        ...form,
        arquivo_certificado_base64: '',
      })
    }

    if (
      files[0]?.type == 'application/pkcs12' ||
      files[0]?.type == 'application/x-pkcs12'
    ) {
      setForm({
        ...form,
        arquivo_certificado_base64: files[0],
      })
    } else {
      setForm({
        ...form,
        arquivo_certificado_base64: '',
      })
    }
  }

  const fetchCnpj = async cnpj => {
    try {
      const resp = await fetchCnpjInfo(cnpj)

      if (resp?.data) {
        const { data } = resp

        setForm({
          ...form,
          nome: data?.razao_social,
          cep: data?.endereco?.cep,
          municipio: data?.endereco?.municipio,
          numero: data?.endereco?.numero,
          uf: data?.endereco?.uf,
          logradouro: data?.endereco?.logradouro,
          complemento: data?.endereco?.complemento,
          bairro: data?.endereco?.bairro,
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const handleSearchCep = async cep => {
    const currentCep = cep?.replace(/\D/g, '')

    if (currentCep?.length != 8) return

    try {
      const resp = await fetchViaCep(currentCep)

      if (resp?.erro) return

      setForm(prev => ({
        ...prev,
        logradouro: resp?.logradouro || prev.logradouro,
        bairro: resp?.bairro || prev.bairro,
        municipio: resp?.localidade || prev.municipio,
        uf: resp?.uf || prev.uf,
        complemento: resp?.complemento || prev.complemento,
      }))
    } catch (e) {
      console.log(e)
    }
  }

  const handleValidCnpj = cnpj => {
    const valueHasSize = cnpj.length == 18

    if (valueHasSize) {
      const validCnpj = isCpfCnpjValid(cnpj)

      if (validCnpj) {
        setValidatedForm({
          ...validatedForm,
          cnpj: '',
        })

        fetchCnpj(cnpj)
      } else {
        setValidatedForm({
          ...validatedForm,
          cnpj: 'CNPJ inválido',
        })
      }
    } else {
      setValidatedForm({
        ...validatedForm,
        cnpj: 'CNPJ inválido',
      })
    }
  }

  const handleValidateForm = () => {
    let hasFormError = false

    const formKeys = Object.keys(form)
    const validatedFormKeys = Object.keys(validatedForm)

    const commonKeys = formKeys.filter(key => validatedFormKeys.includes(key))

    const currentForm = { ...validatedForm }

    commonKeys.forEach(key => {
      if (haveRegistration && !ignoreIfHaveRegistration.includes(key)) {
        if (!form[key]) {
          hasFormError = true
          currentForm[key] = 'Preencha o campo'
        } else {
          currentForm[key] = ''
        }
      }

      if (!haveRegistration) {
        if (!form[key]) {
          hasFormError = true
          currentForm[key] = 'Preencha o campo'
        } else {
          currentForm[key] = ''
        }
      }
    })

    if (validatedForm.cnpj) {
      handleValidCnpj(form.cnpj)
    }

    setValidatedForm(currentForm)

    return hasFormError
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const hasFormError = handleValidateForm()

    if (hasFormError) {
      return dispatch({
        type: SNACKBAR.HARDFAIL,
        error: { message: 'Complete todos os campos do formulário' },
      })
    }

    const data = new FormData()

    Object.entries(form).forEach(([key, value]) => {
      data.append(key, value)
    })

    data.delete('logo_path')

    try {
      if (haveRegistration) {
        const resp = await update(data)
        return dispatch({
          type: SNACKBAR.SOFTSUCCESS,
          success: { message: 'Empresa atualizada com sucesso' },
        })
      }

      const resp = await store(data)
      setHaveRegistration(true)
      dispatch({
        type: SNACKBAR.SOFTSUCCESS,
        success: { message: 'Empresa cadastrada com sucesso' },
      })
    } catch (e) {
      dispatch({
        type: SNACKBAR.HARDFAIL,
        error: { message: 'Erro ao completar o formulário' },
      })
    }
  }

  useEffect(() => {
    setForm({
      ...form,
      ...registrationData,
    })
  }, [registrationData])

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={4}>
            {/* {!haveRegistration && ( */}
            <Grid item xs={12}>
              <Box className={classes.details_box}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={4}>
                      <Grid item xs={12} sm={6} md={3}>
                        <ReactInputMask
                          mask="99.999.999/9999-99"
                          name="cnpj"
                          maskChar=""
                          value={form?.cnpj}
                          required
                          readOnly={haveRegistration}
                          onChange={handleChange}
                          onBlur={e => {
                            if (!haveRegistration) {
                              handleValidCnpj(e.target.value)
                            }
                          }}
                        >
                          {inputProps => (
                            <TextField
                              {...inputProps}
                              label="CNPJ"
                              fullWidth
                              error={validatedForm.cnpj}
                              helperText={validatedForm.cnpj}
                            />
                          )}
                        </ReactInputMask>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <TextField
                          label="Razão Social"
                          name="nome"
                          required
                          fullWidth
                          value={form?.nome}
                          onChange={handleChange}
                          error={validatedForm.nome}
                          helperText={validatedForm.nome}
                        />
                      </Grid>

                      {form.arquivo_certificado_base64 && (
                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            label="Senha do Certificado"
                            name="senha_certificado"
                            required
                            type="password"
                            fullWidth
                            value={form?.senha_certificado}
                            onChange={handleChange}
                            error={validatedForm.senha_certificado}
                            helperText={validatedForm.senha_certificado}
                          />
                        </Grid>
                      )}

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md
                        container
                        alignItems="flex-end"
                        justifyContent="flex-end"
                      >
                        <Grid
                          item
                          xs={form.arquivo_certificado_base64 ? 12 : 4}
                        >
                          <input
                            ref={inputRef}
                            name="logo"
                            type="file"
                            accept=".pfx,.p12"
                            onChange={handleChangeCertificate}
                            style={{ display: 'none' }}
                          />
                          <IconButton
                            onClick={handleChooseFile}
                            className={classes.uploadLogo}
                          >
                            <Grid container spacing={1}>
                              <Grid
                                item
                                xs={12}
                                container
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Icon path={mdiProgressUpload} size={1} />
                                {haveRegistration
                                  ? 'Certificado'
                                  : 'Anexar Certificado'}
                              </Grid>
                              <Grid item xs={12}>
                                {haveRegistration &&
                                !form.arquivo_certificado_base64 ? (
                                  <Typography
                                    className={classes.cartifacateValidate}
                                  >
                                    Válido até {form?.validade_certificado}
                                  </Typography>
                                ) : (
                                  <Typography
                                    className={classes.certificateStatus}
                                  >
                                    Certificado Digital:
                                    {form.arquivo_certificado_base64
                                      ? 'Válido'
                                      : 'Ausente'}
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} style={{ marginTop: '1em' }}>
                  <Grid container spacing={4}>
                    <Grid item xs={12}>
                      <Box className={classes.subTitle}>Identificação</Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Forms.identification
                        form={form}
                        validatedForm={validatedForm}
                        handleChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Box className={classes.subTitle}>Contato</Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Forms.contact
                        form={form}
                        validatedForm={validatedForm}
                        handleChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Box className={classes.subTitle}>Endereço</Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Forms.address
                        form={form}
                        validatedForm={validatedForm}
                        handleChange={handleChange}
                        handleSearchCep={handleSearchCep}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Box className={classes.subTitle}>Responsável</Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Forms.responsible
                        form={form}
                        validatedForm={validatedForm}
                        handleChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Box className={classes.subTitle}>Documentos Fiscais</Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Forms.documents
                        form={form}
                        validatedForm={validatedForm}
                        handleChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Box className={classes.subTitle}>Logo</Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Forms.logo
                        form={form}
                        setForm={setForm}
                        classes={classes}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container justifyContent="flex-end">
                    <Button
                      className={classes.btnSave}
                      type="submit"
                      onClick={handleValidateForm}
                      loading
                    >
                      Salvar
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            {/* )} */}
          </Grid>
        </form>
      </Grid>
    </Grid>
  )
}

export default LaundryConfig
